<template>
  <div>
    <div class="grid-container" :class="{'sidebar-hidden': !is_sidebar, 'compact': $compact_view(), 'popup': $popup_view(), 'sidebar-resizing': sidebar_resizing}" :style="{'--sidebar-width': sidebar_width + 'px'}">
      <!-- header -->
      <header class="header" v-if="!$compact_view()">

        <div class="header-sidebar-icon">
          <k-btn @click.stop="drawer = !drawer" icon><k-icon>menu</k-icon></k-btn>
        </div>

        <div class="header-logo">
          <img src="../assets/kepit_logo_full.png" style="height: 35px;" class="header-logo">
        </div>

        <div class="header-topbar">
          <router-view name="topbar"></router-view>
        </div>

        <div class="header-maintenance">
          <div v-if="maintenance.running">
            <k-chip color="danger" icon="info" v-tooltip.bottom="'<b>Estimated time to complete:</b> <br/>' + format_date(maintenance_end_timestamp) + ' ' + format_time(maintenance_end_timestamp) + '<br/><br/><b>Message:</b> <br/>' + maintenance_message">
              System maintenance begins on {{maintenance_start_timestamp | format_date}} at {{maintenance_start_timestamp | format_time}}.
            </k-chip>
          </div>
        </div>

        <div class="header-search">
          <k-search-bar v-model="search_text" v-if="is_search" style="width: 100%;">
            <router-view name="searchbar"></router-view>
          </k-search-bar>
        </div>

        <div class="header-time">
          <div v-if="$is_admin() || $account_type() == 'user'" class="pl-2 pr-2">
            {{timestamp | format_date}} - {{timestamp | format_time_seconds}} {{timestamp | format_time_timezone}}
          </div>
        </div>

        <div class="header-user-icon">
          <k-icon>account_circle</k-icon>
        </div>

        <div class="header-user-email">
          {{current_name || current_email}}
        </div>
      </header>

      <header class="header" :class="{'header-compact': $compact_view()}" v-if="$compact_view()">
        <div style="padding-top: 5px;">
          <img src="../assets/kepit_logo_full.png" style="height: 35px;">
        </div>
        <div>
          <k-search-bar v-model="search_text" v-if="is_search" style="width: 100%;">
            <router-view name="searchbar"></router-view>
          </k-search-bar>
        </div>
        <div>
          {{current_name || current_email}}
        </div>
        <div>
          <k-btn flat @click="logout">Logout</k-btn>
        </div>
      </header>

      <!-- Menu -->
      <nav class="nav-bar hide-scrollbar">
        <k-btn v-for="item in filtered_items" :key="item.title" :to="item.url" flat tile list hover-class="menu-active" no-hover class="nav-bar-btn">
          <div class="nav-bar-btn-div">
            <k-icon inherit class="nav-bar-icon">{{item.icon}}</k-icon>
            <div class="nav-bar-text">{{item.title}}</div>
          </div>
        </k-btn>
        <k-divider class="nav-bar-divider"></k-divider>
        <k-btn flat tile list hover-class="menu-active" ho-nover class="nav-bar-btn" @click="logout">
          <div class="nav-bar-btn-div">
            <k-icon inherit class="nav-bar-icon">power_settings_new</k-icon>
            <div class="nav-bar-text">Logout</div>
          </div>
        </k-btn>
        <k-divider class="nav-bar-divider"></k-divider>
      </nav>

      <!-- Sidebar -->
      <aside class="sidebar">
        <template v-if="is_sidebar">
          <router-view name="sidebar"></router-view>
          <div class="sidebar-resize-handle" @mousedown.prevent="start_sidebar_resize" @dblclick="reset_sidebar_width" title="Drag to resize, double-click to reset"></div>
        </template>
      </aside>

      <!-- Content -->
      <main class="main-content">
        <div class="content-body">
          <Loading :visible="loading || loadingEventInfos || maintenance_running" :error="alert || alertEventInfos">
              <div v-show="!alert && !loading && !alertEventInfos && !loadingEventInfos && !maintenance_running" style="height: 100%;">
               <router-view></router-view>
              </div>
              <div slot="infoContent">
                <template v-if="maintenance_running">
                  <div style="margin-bottom: 1em; color: var(--ks-col-warning);"><b>Maintenance is currently running. </b></div>
                  <div><b>Estimated time to complete:</b></div>
                  <div>{{maintenance_end_timestamp | format_date}} {{maintenance_end_timestamp | format_time}}</div>
                  <div style="margin-top: 1em;"><b>Message:</b></div>
                  <div><span v-html="message"></span></div>
                </template>
                <template v-else>
                  Sorry, Something went wrong!
                </template>
              </div>
              <div slot="right">
                <k-btn @click="reload" icon><k-icon>cached</k-icon></k-btn>
              </div>
          </Loading>
        </div>
        <footer class="footer mb-1 mr-1" v-if="!$compact_view()" style="display: grid; grid-template-rows: max-content max-content; grid-gap: 4px;">
          <div>
<!--            <div v-show="main_monitor">
              MainMonitor

            </div>-->
          </div>
          <div style="display: grid; grid-template-columns: 1fr max-content; gripd-gap: 4px; ">
            <processbar v-model="processbar"></processbar>
<!--
            <div style="width: 40px; align-content: end;">
              <div @click="main_monitor = !main_monitor" class="main-monitor-button" :class="{'main-monitor-button-active': main_monitor}">
                <k-icon size="m">preview</k-icon>
              </div>
            </div>-->
          </div>
        </footer>

      </main>
    </div>
  </div>
</template>

<script>
import Processbar from './Processbar'
import Loading from "./Loading"
import datelib from '../lib/date.js';
import moment from 'moment';
import SettingsModel from '@/models/settings.js';

const SIDEBAR_DEFAULT_WIDTH = 340;
const SIDEBAR_MIN_WIDTH = 200;
const SIDEBAR_MAX_WIDTH = 800;
const SIDEBAR_WIDTH_KEY = "sidebar_width";

export default {
  components: {
    Processbar,
    Loading
  },
  filters: datelib,

  data () {
    return {
      loading: false,
      alert: false,
      loadingEventInfos: false,
      alertEventInfos: false,
      counter: 0,
      drawer: true,
      mini: false,
      processbar: false,
      main_monitor: false,
      sidebar_width: SIDEBAR_DEFAULT_WIDTH,
      sidebar_resizing: false,
      items: [
        {title: "Dashboard", icon: "dashboard", url: "/dashboard", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user"]},
        {title: "Productions", icon: "inventory", url: "/productions", router: true, access: ["admin", "device_admin", "developer"], group_meta: ["productions"]},
        {title: "Events", icon: 'event', url: "/events", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user"]},
        {title: "Clips", icon: 'movie_edit', url: "/cloudrec", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user", "cloudrec"]},
        {title: "Content", icon: 'view_list', url: "/content", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user", "cloudrec"]},
        {title: "Channels", icon: 'movie', url: "/channels", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user"]},
        {title: "Instances", icon: 'settings_ethernet', url: "/instances", router: true, access: ["admin", "device_admin", "root", "developer"]},
        {title: "Devices", icon: 'computer', url: '/devices', router: true, access: ["device_admin", "root", "developer"]},
        {title: "Billing", icon: 'savings', url: '/billing', router: true, access: ["admin", "device_admin", "root", "developer"]},
        {title: "Monitor", icon: 'ondemand_video', url: "/monitor", router: true, access: ["admin", "device_admin", "root", "developer"]},
        {title: "Sys Monitor", icon: 'ondemand_video', url: "/sysmonitor", router: true, access: ["admin", "device_admin", "root", "developer"]},
        {title: "Multiview", icon: 'view_module', url: "/multiview", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user"]},
        {title: "Settings", icon: "settings", url: "/settings", router: true, access: ["admin", "device_admin", "root", "developer", "group_admin", "user"]},
        {title: "Developer", icon: "developer_board", url: "/developer", router: true, access: ["developer"]},

      ]
    }
  },

  watch: {
    loading (newVal) {
      if(!newVal && !this.loadingEventInfos && !this.$root.loaded) this.$root.loaded = true;
    },
    loadingEventInfos (newVal) {
      if(!this.loading && !newVal && !this.$root.loaded) this.$root.loaded = true;
    },
    '$route' (to, from) {
      var to_parts = to.path.split("/");
      var from_parts = from.path.split("/");

      if (to_parts.length > 1 && from_parts.length > 1 && to_parts[1] != from_parts[1]) {
        this.search_text = "";
      }

      var section_changed = to_parts[1] != from_parts[1];
      if (this.route_has_sidebar(to) && (section_changed || !this.route_has_sidebar(from))) {
        this.drawer = true;
      }
    }
  },
  computed: {
    is_search () {
      if (this.$route.meta && this.$route.meta.search === false) return false;;
      return true;
    },
    search_text: {
      get: function() {
        return this.$store.state.search_text;
      },
      set: function(newValue) {
        this.$store.commit("set_search_text", newValue);
      }
    },
    is_sidebar () {
      var ret = false;
      _.each(this.$route.matched, function(route) {
        if (_.includes(Object.keys(route.components), "sidebar")) {
          ret = true;
        }
      });
      if (ret == true && this.drawer == false) return false;
      return ret;
    },
    timestamp () {
      return this.$store.state.timestamp;
    },
    filtered_items () {
      var is_admin = this.$is_admin();
      var account_type = this.$store.getters.account_type;
      var groups = this.$store.getters.groups;
      return _.filter(this.items, function(item) {
        if (typeof(item.access) == "undefined" && typeof(item.group_meta) == "undefined") return true;
        if (item.access.includes(account_type)) return true;
        if (typeof(item.group_meta) != "undefined") {
          var group = _.find(groups, function(g) {
            if (g.meta[item.group_meta] == true) return true;
          });
          if (typeof(group) != "undefined") return true;
        }
        return false;
      });
    },
    account_type () {
      return this.$store.getters.account_type;
    },
    current_email () {
      return (this.$store.state.account||{}).email;
    },
    current_name () {
      if(typeof(this.$store.state.account) == "undefined") return undefined;
      if(!this.$store.state.account.name || !this.$store.state.account.surname) return undefined;
      return this.$store.state.account.name + " " + this.$store.state.account.surname;
    },
    maintenance() {
      return this.$store.state.maintenance;
    },
    maintenance_start_timestamp() {
      return _.get(this.maintenance, "info.start_time");
    },
    maintenance_end_timestamp() {
      return _.get(this.maintenance, "info.end_time");
    },
    maintenance_message() {
      return _.get(this.maintenance, "info.message");
    },
    maintenance_running() {
      var account = (this.$store.state.account||{})
      var setting = SettingsModel.get_by_name("maintenance") || {value: {bypass_accounts: []}};
      return this.maintenance.running && this.maintenance.info.start_time <= (this.timestamp || moment().unix()) && setting.value.bypass_accounts.indexOf(account.id) == -1;
    }
  },
  methods: {
    route_has_sidebar(route) {
      return _.some(route.matched, (r) => _.includes(Object.keys(r.components), "sidebar"));
    },
    format_date(ts) {
      return datelib.format_date(ts);
    },
    format_time(ts) {
      return datelib.format_time(ts);
    },
    logout () {
      if(!confirm("Do you really want to log out?")) return;

      this.$store.dispatch("log_out").then(() => {
        this.$router.push({
          path: "/login",
          query: {l: 1}
        })
      },
      (error) => {
        console.log(error.response);
        alert(error.msg);
      });
    },
    reload () {
      location.reload();
    },
    clamp_sidebar_width (width) {
      var max = Math.min(SIDEBAR_MAX_WIDTH, window.innerWidth - 200);
      return Math.round(Math.max(SIDEBAR_MIN_WIDTH, Math.min(max, width)));
    },
    start_sidebar_resize (event) {
      this.resize_start_x = event.clientX;
      this.resize_start_width = this.sidebar_width;
      this.sidebar_resizing = true;
      document.addEventListener("mousemove", this.on_sidebar_resize);
      document.addEventListener("mouseup", this.stop_sidebar_resize);
    },
    on_sidebar_resize (event) {
      this.sidebar_width = this.clamp_sidebar_width(this.resize_start_width + event.clientX - this.resize_start_x);
    },
    stop_sidebar_resize () {
      this.sidebar_resizing = false;
      document.removeEventListener("mousemove", this.on_sidebar_resize);
      document.removeEventListener("mouseup", this.stop_sidebar_resize);
      try { localStorage.setItem(SIDEBAR_WIDTH_KEY, this.sidebar_width); } catch (e) {}
    },
    reset_sidebar_width () {
      this.sidebar_width = SIDEBAR_DEFAULT_WIDTH;
      try { localStorage.removeItem(SIDEBAR_WIDTH_KEY); } catch (e) {}
    }
  },
  mounted () {
    var stored = null;
    try { stored = parseInt(localStorage.getItem(SIDEBAR_WIDTH_KEY), 10); } catch (e) {}
    if (stored) this.sidebar_width = this.clamp_sidebar_width(stored);
  },
  beforeDestroy () {
    document.removeEventListener("mousemove", this.on_sidebar_resize);
    document.removeEventListener("mouseup", this.stop_sidebar_resize);
  },
  socket: {
    open () {
      this.loading = false;
      this.alert = false;
      this.counter = 0;
    },
    close (msg) {
      this.loading = true;
      if(this.counter > 3) {
        this.alert = true;
      } else {
        this.counter = this.counter + 1;
      }
    }
  }
}
</script>
<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.grid-container {
  display: grid;
  height: 100vh; /* Koko ruudun korkeus */
  height: 100dvh;
  width: 100vw;  /* Koko ruudun leveys */
  
  /* Rivejä on kaksi: yläpalkki (40px) ja lopputila (1fr) */
  grid-template-rows: 40px 1fr;
  
  /* Sarakkeita on kolme: valikko (80px), sivupalkki (350px) ja sisältö (loput) */
  grid-template-columns: 80px var(--sidebar-width, 340px) 1fr;
  grid-gap: 0px;

  /* Määritellään alueet (Grid Areas) */
  grid-template-areas:
    "header  header  header"
    "navbar  sidebar main";
}

.header {
  grid-area: header;
  align-items: center;
  padding: 0 0px;
  padding-right: 20px;
  display: grid;
  background-color: var(--ks-background-color-light);
  grid-template-columns: 80px max-content 1fr max-content 400px max-content max-content max-content;
  grid-template-areas: "sidebar-icon logo topbar maintenance search time user-icon user-email";
  grid-gap: 10px;
  position: relative;
  overflow: hidden;
  align-content: center;
}
.header .header-sidebar-icon {
  grid-area: sidebar-icon;
  text-align: center; 
  width: 100%;
}

.header .header-logo {
  grid-area: logo;
  padding-top: 5px;
}
.header .header-topbar {
  grid-area: topbar;
}
.header .header-maintenance {
  grid-area: maintenance;
}
.header .header-search {
  grid-area: search;
}
.header .header-time {
  font-family: Roboto;
  grid-area: time;
}
.header .header-user-icon {
  grid-area: user-icon;
}
.header .header-user-email {
  grid-area: user-email;
}
/*
@media (max-width: 1200px) {
  .header {
    grid-template-columns: max-content max-content 1fr max-content;
    grid-template-areas: "sidebar-icon logo search time";
  .header .header-topbar {
    display: none;
  }
  .header .header-maintenance {
    display: none;
  }
  .header .header-user-icon {
    display: none;
  }
  .header .header-user-email {
    display: none;
  }    
  }
}*/

@media (max-width: 768px) {
  .header {
    grid-template-columns: max-content max-content 1fr;    
    grid-template-areas: "sidebar-icon logo search";
  }
  .header .header-time {
    display: none;
  }
  .header .header-topbar {
    display: none;
  }
  .header .header-maintenance {
    display: none;
  }
  .header .header-user-icon {
    display: none;
  }
  .header .header-user-email {
    display: none;
  }
  .grid-container {
    /* Rivejä on kaksi: yläpalkki (40px) ja lopputila (1fr) */
    grid-template-rows: 40px 1fr 40px;
  
    /* Sarakkeita on kolme: valikko (80px), sivupalkki (350px) ja sisältö (loput) */
    grid-template-columns: 340px 1fr;
    grid-gap: 5px;
  
    /* Määritellään alueet (Grid Areas) */
    grid-template-areas:
    "header header"
    "sidebar main"
    "navbar navbar";
  }
  .nav-bar {
    display: flex;
  }
}

.header.header-compact {
  grid-template-columns: 1fr 400px max-content max-content;
}

/*.header::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  
  background-image: url('/topbarbg.jpg');;
  background-size: cover;
  background-position: center;
  
  filter: blur(30px);
  transform: scale(1.1);
  
  z-index: -1; 
}*/


.nav-bar {
  grid-area: navbar;
  position: relative; /* Tärkeä: kiinnittää taustakuvan oikeaan paikkaan */
  overflow-y: auto;
  overflow-x: hidden;
  background-color: var(--ks-background-color-light);
}

/*
.nav-bar::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  
  background-image: url('/menubg.jpg');
  background-size: cover;
  background-position: center;
  
  filter: blur(30px);
  transform: scale(1.1);
  
  z-index: -1;
}*/

.nav-bar .nav-bar-btn {
  margin: 0px; 
  height: 50px; 
  width: 100%;
  text-align: center; 
  background: transparent;
}
.nav-bar .nav-bar-btn .nav-bar-btn-div {
  display: grid; 
  grid-template-rows: 1fr 1fr; 
  font-size: var(--ks-font-size-xxs);
  width: 100%; 
  text-transform: none;
}
.nav-bar .nav-bar-icon {
  text-align: center; 
  font-size: 20px;
}
.nav-bar .nav-bar-text {
  white-space: nowrap; 
  overflow: hidden;
}

.sidebar {
  grid-area: sidebar;
  transition: width 0.3s ease, min-width 0.3s ease;
  overflow: hidden; 
  display: flex;
  position: relative;
  flex-direction: column; 
  height: 100%;
}

.sidebar-resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 6px;
  height: 100%;
  cursor: col-resize;
  z-index: var(--ks-z-page-controls, 3);
}
.sidebar-resize-handle::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: 100%;
  background-color: var(--ks-col-accent);
  opacity: 0;
  transition: opacity 0.2s ease;
}
.sidebar-resize-handle:hover::after {
  opacity: 0.35;
  transition-delay: 0.3s;
}
.grid-container.sidebar-resizing .sidebar-resize-handle::after {
  opacity: 0.6;
  transition-delay: 0s;
}
.grid-container.sidebar-resizing {
  cursor: col-resize;
  user-select: none;
}
.grid-container.sidebar-resizing iframe,
.grid-container.sidebar-resizing video {
  pointer-events: none;
}

.main-content {
  grid-area: main;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: hidden; 
}

.content-body {
  flex-grow: 1;
  padding: var(--ks-padding-2); 
  border-radius: 6px;
  overflow-y: auto;
}

.footer {
  padding-left: var(--ks-padding-2);
  padding-right: var(--ks-padding-2);
  flex-shrink: 0;
}


/* Kun tämä luokka on aktiivinen, sivupalkin sarake muuttuu nollaksi */
.grid-container.sidebar-hidden {
  grid-template-columns: 80px 0px 1fr;
}

/* Piilotetaan sivupalkin sisältö, kun se menee kasaan */
.grid-container.sidebar-hidden .sidebar {
  border: none;
}

.grid-container.compact {
  grid-template-columns: 0px 0px 1fr;
}

.grid-container.popup {
  grid-template-rows: 0px 1fr;
}

</style>

<style scoped>
.main-monitor-button {
  background: var(--ks-background-color); 
  border-radius: 6px; 
  width: 40px; 
  height: 35px; 
  align-content: center; 
  text-align: center;
  cursor: pointer;
}
.main-monitor-button:hover {
  background: var(--ks-background-color-light);
}
.main-monitor-button-active {
  color: var(--ks-col-accent);
}

.content-with-sidebar {
  margin-left: 430px !important;
}
.progressbar-with-sidebar {
  left: 437px !important;
}
.hide-scrollbar {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}
.hide-scrollbar::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
}
.compact-margin {
  margin-left: 0px !important;
  padding-top: 0px !important;

}

.menu-active {
  color: rgb(248,216,74) !important;
  border-color: transparent !important;
  background-color: transparent !important;
}


@media (max-width: 768px) {
  .header {
    grid-template-columns: max-content max-content 1fr;    
    grid-template-areas: "sidebar-icon logo search";
  }
  .header .header-time {
    display: none;
  }
  .header .header-topbar {
    display: none;
  }
  .header .header-maintenance {
    display: none;
  }
  .header .header-user-icon {
    display: none;
  }
  .header .header-user-email {
    display: none;
  }
  .grid-container {
    /* Rivejä on kaksi: yläpalkki (40px) ja lopputila (1fr) */
    grid-template-rows: 40px 1fr 80px;
  
    /* Sarakkeita on kolme: valikko (80px), sivupalkki (350px) ja sisältö (loput) */
    grid-template-columns: 340px 1fr;
    grid-gap: 5px;
  
    /* Määritellään alueet (Grid Areas) */
    grid-template-areas:
    "header header"
    "sidebar main"
    "navbar navbar";
  }
  .nav-bar {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 60px;
    grid-gap: 8px;
    -webkit-overflow-scrolling: touch;
    background: var(--ks-background-color-light);
    padding-left: 10px;
  }
  .nav-bar:before {
    display: none;
  }
  .nav-bar .nav-bar-btn {
    padding: 0px;
    height: 100px;
    text-align: center; 
    background: transparent;
    font-size: 14px;
  }
  .nav-bar .nav-bar-divider {
    display: none;
  }
  .nav-bar .nav-bar-icon {
    font-size: 28px;
  }
  .grid-container.sidebar-hidden {
    grid-template-columns: 0px 1fr;
  }
  .sidebar-resize-handle {
    display: none;
  }
  .footer {
    display: none;
  }

}
</style>
